import { Component, OnInit } from "@angular/core";
import { PaysService } from "../services/pays.service";
import { SpinnerService } from "src/app/services/spinner.service";
import { Router } from "@angular/router";
import { PaymentInfo } from "../model/paymentInfo";
import { SharedStateService } from "src/app/services/shared-state.service";
import { LiveAnnouncer } from '@angular/cdk/a11y';

@Component({
    selector: 'app-receipt',
    templateUrl: './receipt.component.html',
    styleUrl: './receipt.component.scss'
  })
  export class ReceiptComponent implements OnInit {

  constructor(
      private paysService: PaysService,
      private spinnerService:SpinnerService,
      private sharedService: SharedStateService,
      private router: Router,
      private liveAnnouncer: LiveAnnouncer 
    ){}
  
  receitpModel:any;
  paymentInfo: PaymentInfo | undefined;
  showReceipt:boolean = false;
  orderId: string = "";
  ngOnInit(): void {
      this.liveAnnouncer.announce('Paynow Receipt');
      this.spinnerService.showSpinner();
      this.showReceipt = false;
      this.orderId = this.sharedService.getState('orderId');
      this.paysService.orderReceipt().subscribe({
        next:(value: any)=> {
          this.receitpModel=value;
          this.paymentInfo = this.sharedService.getState('paymentInfo');
          this.sharedService.removeState('paymentInfo');
          this.spinnerService.hideSpinner();
          this.showReceipt = true;
        },
        error:(e)=>{
          this.spinnerService.hideSpinner();
          this.paymentInfo = this.sharedService.getState('paymentInfo');
          this.sharedService.removeState('paymentInfo');
          this.showReceipt = true;
        }
      })
    }

    subTotalAmount(){
      if(this.receitpModel.paymentAmount&&this.receitpModel.feeItems)
        return this.receitpModel.paymentAmount-this.receitpModel.feeItems[0].amount;
      return 0;
    }

    get partnerName(){
      if(this.paymentInfo){
        return this.paymentInfo.partnerName
      }

      return "";
    }

    get paymentSummary(){
      let summary = "";
      if(this.receitpModel && this.receitpModel.paymentInfo){
        if(this.receitpModel.paymentInfo.paymentMethod === "CreditCard"){
          summary = this.receitpModel.paymentInfo.cardType + " ending with " + this.receitpModel.paymentInfo.cardSummary;
        } else if(this.receitpModel.paymentInfo.paymentMethod === "BankAccount") {
          summary = "Account number ending with " + this.receitpModel.paymentInfo.bankAccountSummary
        }
      }

      return summary;
    }

    get disclaimer(){
      let disclaimer = "";
      if(this.receitpModel && this.receitpModel.disclaimers && this.receitpModel.disclaimers.length > 0){
        disclaimer = this.receitpModel.disclaimers.join('\n');
      }

      return disclaimer;
    }

    public printReceipt() {
      window.focus();
      window.print();
    }
    returnURL(){
      window.location.href = String(this.paymentInfo?.cancelURL);
    }
  }

  